import React from 'react';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import AppHeader from 'components/AppHeader/AppHeader';
import LayoutFooter from 'components/Layout/Footer/Footer';
import AdminImpersonationBanner from 'components/Admin/Impersonation/ImpersonationBanner/ImpersonationBanner';
import { useImpersonation } from 'components/Admin/Impersonation/useImpersonation';
import classnames from 'classnames';

import './BaseLayout.scss';

export default function BaseLayout({
  children,
  className = '',
  reportingOutcome,
}: {
  readonly children: React.ReactNode | React.ReactNode[];
  readonly className?: string;
  readonly reportingOutcome?: boolean;
}) {
  const {
    isImpersonating,
    impersonatedUser,
    endImpersonation,
    isLoading,
  } = useImpersonation();
  return (
    <div
      className={`base-layout__wrapper ${
        reportingOutcome ? 'reporting-outcome' : ''
      }`}
    >
      {reportingOutcome ? (
        <ErrorBoundary>{children}</ErrorBoundary>
      ) : (
        <ErrorBoundary>
          {isImpersonating && impersonatedUser && (
            <AdminImpersonationBanner
              impersonatedUser={impersonatedUser}
              onEndImpersonation={endImpersonation}
              isLoading={isLoading}
            />
          )}
          <AppHeader />
          <div className={classnames('base-layout__content', className)}>
            <div className="base-layout">
              <ErrorBoundary>{children}</ErrorBoundary>
            </div>
          </div>
          {!reportingOutcome ? <LayoutFooter /> : null}
        </ErrorBoundary>
      )}
    </div>
  );
}
